exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-common-styles-___Footer__footer___Eb4tT img {\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"footer": "src-components-common-styles-___Footer__footer___Eb4tT"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader/lib/loader.js!./src/components/common/styles/Footer.sass
// module id = 366
// module chunks = 0